import { useStaticQuery, graphql } from "gatsby"
import { useContext, useEffect, useState } from "react"
import LanguageContext from "../context/LanguageContext"

export const useQuery = () => {
  const { allLocale } = useStaticQuery(
    graphql`
      query MyQuery {
        allLocale(filter: { ns: { eq: "slugs" } }) {
          nodes {
            data
            language
          }
        }
      }
    `
  )

  return allLocale
}

export const useRedirectToPro = () => {
  const { language: contextLanguage } = useContext(LanguageContext)
  const [url, setUrl] = useState("")

  useEffect(() => {
    let language = contextLanguage || "en"

    if (!["es", "de"].includes(language)) {
      language = "en"
    }

    // Ensure the URL always ends with a slash
    const baseUrl = process.env.GATSBY_SITE_URL + "/pro/?lng=" + language
    const formattedUrl = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/"

    setUrl(formattedUrl)
  }, [contextLanguage])

  return url
}

export const useCaseStudiesUrl = () => {
  const [url, setUrl] = useState("https://www.metaloop.com/case-studies/")
  useEffect(() => {
    if (window.location.host === "www.metaloop.com") {
      setUrl("https://www.metaloop.com/case-studies/")
    } else {
      setUrl("https://qa.metaloop.com/case-studies/")
    }
  }, [setUrl])
  return url
}

export const useCaseStudiesEach = ({ lang = "en" } = {}) => {
  const [url, setUrl] = useState(`https://www.metaloop.com/case-studies`)

  const getLanguage = () => {
    let lang = ""
    const storedLanguage = localStorage.getItem("lastChosenLanguage")
    if (storedLanguage) {
      lang = storedLanguage
    } else {
      const userLanguage = navigator.language
      if (userLanguage.includes("es")) {
        lang = "es"
      } else if (userLanguage.includes("de")) {
        lang = "de"
      }
    }
    return lang
  }

  useEffect(() => {
    const language = getLanguage()
    if (language === "en")
      if (window.location.host === "www.metaloop.com") {
        setUrl(`https://www.metaloop.com/case-studies`)
      } else {
        setUrl(`https://qa.metaloop.com/case-studies`)
      }
    else if (window.location.host === "www.metaloop.com") {
      setUrl(`https://www.metaloop.com/${language}/case-studies`)
    } else {
      setUrl(`https://qa.metaloop.com/${language}/case-studies`)
    }
  }, [lang, setUrl])

  return url
}

export const useRedirectToPartnerUI = () => {
  const [url, setUrl] = useState("https://app.metaloop.com/")

  useEffect(() => {
    if (window.location.host === "www.metaloop.com") {
      setUrl("https://app.metaloop.com/")
    } else {
      setUrl("https://app-qa.metaloop.com/")
    }
  }, [])

  return url
}

export const useSiteMetadata = (slug, multilanguage = true) => {
  const context = useContext(LanguageContext)

  const allLocale = useQuery()

  const AVAILABLE_PORTAL_GENERIC_LANGUAGES = ["en", "es", "de"]

  const getOneUrl = (context, allLocale, slug) => {
    var url = slug

    // special case for Proform
    if (url === "pro") {
      if (context.language === "en") return `/pro/`
      else return `/pro/?lng=${context.language}`
    }

    if (context.language !== undefined) {
      var currentLanguage = allLocale.nodes.filter(translation => {
        return translation.language === context.language
      })

      if (currentLanguage.length > 0) {
        var objWithTranslations = JSON.parse(currentLanguage[0].data)

        url =
          objWithTranslations[slug] !== undefined
            ? objWithTranslations[slug]
            : slug
      }
    }

    return (
      "/" +
      (AVAILABLE_PORTAL_GENERIC_LANGUAGES.includes(context.language)
        ? context.language === "en"
          ? ""
          : context.language + "/"
        : "") +
      (url ? url + "/" : "")
    )
  }

  return { url: getOneUrl(context, allLocale, slug) }
}

export const useURLforArray = arrSlug => {
  const context = useContext(LanguageContext)
  const allLocale = useQuery()

  var rst = {}
  let contextLanguage = context.language

  if (["es", "de", "en"].includes(contextLanguage) === false) {
    contextLanguage = "en"
  }

  if (contextLanguage !== undefined) {
    var currentLanguage = allLocale.nodes.filter(translation => {
      return translation.language === contextLanguage
    })

    if (currentLanguage.length > 0) {
      var objWithTranslations = JSON.parse(currentLanguage[0].data)

      arrSlug.forEach(slug => {
        if (typeof slug === "string" && slug.startsWith("http"))
          rst[slug] = slug
        else {
          const noLanguage = contextLanguage === "en"
          if (slug === "") {
            rst[slug] =
              contextLanguage === "en" ? "/" : "/" + contextLanguage + "/"
          } else {
            rst[slug] =
              objWithTranslations[slug] !== undefined
                ? "/" +
                  (noLanguage ? "" : contextLanguage + "/") +
                  objWithTranslations[slug] +
                  "/"
                : "/" + (noLanguage ? "" : contextLanguage + "/") + slug + "/"
          }
        }
      })
    }
  }

  return rst
}

export const useSiteMetadataDifferentLang = (slug, arrLang) => {
  var url = {}
  var newSlug = ""
  const allLocale = useQuery()
  if (arrLang !== undefined) {
    arrLang.forEach(lang => {
      var currentLanguage = allLocale.nodes.filter(translation => {
        return translation.language === lang
      })

      if (currentLanguage.length > 0) {
        var objWithTranslations = JSON.parse(currentLanguage[0].data)

        newSlug =
          objWithTranslations[slug] !== undefined
            ? objWithTranslations[slug]
            : slug
      }

      url[lang] = "/" + (lang === "en" ? "" : lang + "/") + newSlug
    })
  }
  return { url: url }
}
